<template>
    <div class="chips" >
        <div class="chip" v-for="(b, i) in data" :key="i" >
            <div class="permissions v-m t-l" >
                <div class="loyalty" >
                    <img class="icon-loyalty v-m"  :src="_global.assetsRoot + '/vip_img_bp.png'" />
                    <span class="beba loyalty-points fs-1-6" >+{{ b.bp }}</span>
                </div>
            </div>
            <div class="rewards abs-center" >
                <div class="chip-icon reward-icon t-c" >
                    <img :src="_global.assetsRoot + `/chips_${6 - (data.length - 1 - i)}.png`" />
                </div>
            </div>
            <div class="reward-inf" >
                <div class="chip-count reward-count t-c" >
                    <span class="beba fs-2" >{{ fc(b.chips) }}</span>
                </div>
                <div class="price" >
                    <div class="btn price-btn t-c v-m" @click.stop="buy(b.hash, b.currency, b.price)" >
                        <span class="beba fs-2" >R${{ b.price }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import utils from '../../utils/utils.js';
export default {
    props: {
        data: Array,
        extra: Object
    },
    data() {
        return {}
    },
    methods: {
        fc(currency) { return utils.fc(Math.round(currency * (1 + this.extra.chips))) },
        buy(hash, currency, price) {
            this.$emit('buy', { "hash": hash, "currency": currency, "price": price })
        }
    }
}
</script>

<style lang="scss" >
@import "../../assets/css/variables.scss";
.chips {

    .chip {
        background: url($assetRoot + "/bank_dinero_bg.png") bottom no-repeat;

        .rewards {
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/chips.vue